export const account = {
  menu: 'Account settings',
  title: 'Account settings',
  subtitle: 'Your name, password and language.',
  profile: {
    title: 'Profile',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    emailHint: 'Contact your administrator to change your email address.',
    organization: 'Organization',
    save: 'Save',
    saved: 'Profile saved',
  },
  password: {
    title: 'Password',
    current: 'Current password',
    next: 'New password',
    confirm: 'Repeat the new password',
    hint: 'At least 8 characters.',
    mismatch: 'The new passwords do not match',
    wrongCurrent: 'The current password is not correct',
    save: 'Change password',
    saved: 'Password changed',
  },
  language: {
    title: 'Language',
    hint: 'Used for the app on this device.',
  },
  failed: 'Could not save',
};

export type AccountDict = typeof account;
